import { doGetRequest } from '@/tools/axios_';
import { Utils } from '@/tools/utils';
import { Button, Modal } from 'antd';
import React from 'react';
import './function-upgrade.less';

// 推广费-弹窗底部的确认和取消按钮（设计统一样式）
const FunctionUpgrade = (props = {}) => {
    const  guideFinish = async() => {
        const res = await doGetRequest({
            url: '/api/market/product/v1/doneNoviceGuidance',
            params: {
                agencyId: Utils.getOrgId(),
                basicKey: '20241217-batch6',
                basicValue: '',
            }
        })
        if(res.status ===200){
            props.onCancel && props.onCancel();
        }
    }
    const {
        visible = false,
        onCancel
    } = props;
    return <div>
        <Modal
            open={visible}
            closable={false}
            width={540}
            footer={null}
            wrapClassName="upgradeModalCommon"
        >
            <div className="upgradeTxt">
                <div className='title_div'><p>产品自动上架功能来啦</p><img src={require('../../assets/images/product/new 32x16@3x.png')} alt=''/></div>
                <div className='tip_div'>
                    <p><i/>产品库的新产品<em>无需再手动点击上架即可进行推广，后续系统将为您自动上架新产品！</em></p>
                    <p><i/>在您每次登录时，我们会为您提示从上一次登录到当前登录期间上线的所有新产品。若其中有产品需要您做品质规则确认，我们将会在提示中为您展示品质规则；</p>
                </div>
            </div>
            <div className="footerBtnWrap">
                <Button className="footerBtn" type="primary" onClick={() => {
                   guideFinish()
                }}>马上体验</Button>
            </div>
        </Modal>
    </div>;
};


export default FunctionUpgrade;
